export default "__VITE_ASSET__MKf4O$1P__"